module.exports = __webpack_public_path__ + "img/gambling.a58581b1.svg";